import { ArrowRight, Cloud, MagicWand, Rocket } from '@phosphor-icons/react';
import { useNavigate } from 'react-router';
import Xiaozhushou_src from '~/assets/images/xiaozhushou.jpg';
import XiaozhushouV_src from '~/assets/videos/xiaozhushou.mp4';

import './index.less';

const Jianying = () => {
  const navigate = useNavigate();
  return (
    <div className="prt-videos-section">
      <div className="prt-video-row">
        <div className="prt-video-container">
          <video
            muted
            autoPlay // 添加自动播放属性
            loop // 可选：添加循环播放
            playsInline
            preload="metadata"
            className="prt-video"
            poster={Xiaozhushou_src}
          >
            <source src={XiaozhushouV_src} type="video/mp4" />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div className="prt-video-content">
          <h3 className="prt-video-title">剪映小助手</h3>
          <p className="prt-video-description">
            一键将AI生成的视频内容导入剪映，快速完成剪辑与合成，支持本地草稿与云端MP4。
            智能化一键生成剪映草稿，与本地剪映无缝对接，让创作效率倍增。无需繁琐的手动导入步骤，
            让AI智能帮你完成从素材到成片的全流程。
          </p>
          <div className="prt-video-features">
            <div className="prt-video-feature">
              <span className="prt-feature-icon transform rotate-45">
                <Rocket size={24} weight="fill" />
              </span>
              <span>极速导入</span>
            </div>
            <div className="prt-video-feature">
              <span className="prt-feature-icon">
                <MagicWand size={24} weight="fill" />
              </span>
              <span>智能合成</span>
            </div>
            <div className="prt-video-feature">
              <span className="prt-feature-icon">
                <Cloud size={24} weight="fill" />
              </span>
              <span>云端渲染</span>
            </div>
          </div>
          <div className="prt-video-action">
            <button className="prt-video-btn btn btn-primary" onClick={() => navigate('/download', { replace: true })}>
              前往下载
              <ArrowRight className="prt-btn-icon" weight="bold" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Jianying;
